// todo: implement error handling from BlockPopup

import React, {Component} from 'react'

import Popup from '../Popup/index';

import Registry from '../../../registry/index';

class UnblockPopup extends Popup {
    constructor(props) {
        super(props);

        this.showOverlay = true;
        this.afterClosePositionReset = false;
    }

    unblock(user) {
        let siteInterface = Registry.get('siteInterface');

        siteInterface.unblock(user).then(function() {

        }).catch(function() {

        });

        this.close();
    }

    render() {
        let lang = Registry.get('locale');

        let {user} = this.props;

        let className = 'popup popup-unblock-confirmation ' + this.state.visibility;

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                <p dangerouslySetInnerHTML={{__html:lang.unblock_confirm(user)}}></p>
                <a href="#" className="popup-button yes" onClick={() => this.unblock(user)}>{lang.yes}</a>
                <a href="#" className="popup-button no" onClick={() => this.close()}>{lang.no}</a>
             </div>
        )
    }

}

UnblockPopup.generateKey = function(props) { return 'unblock-popup' };
UnblockPopup.mount = function(props, onMount) { return Popup.mount(UnblockPopup, props, onMount) };
UnblockPopup.open = function(props) {
    UnblockPopup.mount(props, (r) => Popup.popups[UnblockPopup.generateKey(props)].open());
};

export default UnblockPopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UnblockPopup/index.js